import React from 'react';
import logo from './logo.svg';
import './App.css';
import Master from '../src/component/master/Master';

function App() {
  return (<>
    <Master/>
    </>
  );
}

export default App;
